import React from 'react';

import Layout from '../../components/Layout';
import Logout from './Logout';


function action({ query }) {
  const component = (
    <Layout>
      <Logout redirect={query.redirect} />
    </Layout>
  );

  return {
    chunks: [],
    title: 'Logout',
    component,
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/routes/logout/index.js